// A file source's params (sources-v2 D10, D13): a loop on the playhead `position`, plus volume. Values live in the preset's `source_settings['file:<id>']`; seconds throughout. `out` absent = the clip's end.
export const RATE_SNAPS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2]

const video_file_schema = {
	run: { type: 'boolean', initial: false, label: 'Play' },
	// Cues keep milliseconds: an unstepped number settles to whole units.
	start: { type: 'number', kind: 'timecode', initial: 0, minimum: 0, step: 0.001, label: 'Start' },
	in: { type: 'number', kind: 'timecode', initial: 0, minimum: 0, step: 0.001, label: 'In' },
	out: { type: 'number', kind: 'timecode', initial: null, minimum: 0, step: 0.001, label: 'Out' },
	mode: { type: 'string', enum: ['loop', 'once', 'pingpong', 'pingpong_loop'], initial: 'loop', label: 'Mode' },
	direction: { type: 'string', enum: ['forward', 'reverse'], initial: 'forward', label: 'Direction' },
	// What moves the playhead: its own rate; the session tempo (in→out spans `beats`, locked to the beat grid); or an audio band, swinging it from the start cue (automation's `rest`) by `gain`, released over `fall` seconds.
	sync: { type: 'string', enum: ['time', 'bpm', 'fft'], initial: 'time', label: 'Sync' },
	beats: { type: 'number', initial: 4, minimum: 1 / 16, maximum: 1024, step: 0.001, label: 'Length' },
	band: { type: 'string', enum: ['low', 'mid', 'high'], initial: 'low', label: 'Band' },
	gain: { type: 'number', initial: 0, minimum: 0, maximum: 10, step: 0.01, label: 'Gain' },
	fall: { type: 'number', initial: 0.25, minimum: 0, maximum: 2, step: 0.01, label: 'Fall' },
	// Shapes the pass along in→out as automation's envelope does (`conformEnvelope`'s spelling; absent = straight).
	envelope: { type: 'object', initial: null, label: 'Envelope' },
	// Shown as the loop's length (in→out ÷ rate); bounded by what a `<video>` takes.
	rate: { type: 'number', initial: 1, minimum: 0.0625, maximum: 16, step: 0.001, label: 'Speed' },
	volume: { type: 'number', kind: 'range', initial: 100, minimum: 0, maximum: 100, step: 1, label: 'Volume' },
}

/** Every mode both ways; a reverse pass is per-frame seeks (D13). BPM sync only repeats: a one-shot has no grid to lock to. */
export const FILE_CAPABILITIES = {
	modes: ['loop', 'once', 'pingpong', 'pingpong_loop'],
	syncModes: ['loop', 'pingpong_loop'],
	directions: ['forward', 'reverse'],
}

export default video_file_schema
